/* eslint-disable */
import config from '../config'

export default {
	setToken (token) {
  	if (window.localStorage) {
  		window.localStorage.setItem(config.appName + '_jwt_token', token)	
  	}
  },
  getToken () {
  	if (window.localStorage) {
  		return window.localStorage.getItem(config.appName + '_jwt_token')
  	}
  	return false
  },
  removeToken () {
  	if (window.localStorage) {
    	window.localStorage.removeItem(config.appName + '_jwt_token')
    }
  },
  /* USERS */
  setUser (user) {
    if (window.localStorage) {
      window.localStorage.setItem(config.appName + '_user', JSON.stringify(user))
    }    
  },
  getUser () {
    if (window.localStorage) {
      return JSON.parse(window.localStorage.getItem(config.appName + '_user'))
    }
    return null
  },
  removeUser () {
    if (window.localStorage) {
      window.localStorage.removeItem(config.appName + '_user')
    }
  },
  /* GENERAL */
  setKey (key,item) {
    if (window.localStorage) {
      let data = typeof item === 'object' || typeof item === 'array' ? JSON.stringify(item) : item
      window.localStorage.setItem(config.appName + '_' + key, data)
    }    
  },
  getKey (key,is_object) {
    if (window.localStorage) {
      let data = window.localStorage.getItem(config.appName + '_' + key)
      return is_object ? JSON.parse(data) : data
    }
    return null
  },
  removeKey (key) {
    if (window.localStorage) {
      window.localStorage.removeItem(config.appName + '_' + key)
    }
  }
}



// WEBPACK FOOTER //
// ./src/core/local-storage.js